/**
 * @fileOverView
 * @description Org Member Model — a member who can manage this account.
 * See docs/org-accounts-spec.md §4.4.
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var app = require("ampersand-app");

var OrgMember = AmpersandModel.extend({

    idAttribute: 'key',

    //revoke is keyed by the member's personKey, not the membership key
    url: function(){
        return app.config.restApiUrl + "/org/member/" + this.personKey;
    },

    ajaxConfig: app.utils.setPersonalAuthTokenHeader,

    props: {
        key : 'string',
        personKey : 'string',
        name : 'string',
        email: 'string',
        role: 'string',
        status: 'string',
        suspended: 'boolean',
        developer_access: 'boolean'
    },

    derived: {

        displayName: {
            deps: ['name','email'],
            fn: function(){
                return this.name || this.email || '';
            }
        },

        statusDisplay: {
            deps: ['status','suspended'],
            fn: function(){
                if(this.status=="invited") return '<span class="vpending">pending</span>';
                if(this.suspended) return '<span class="vsuspended" title="no seat available on your current plan">suspended</span>';
                return ' &nbsp; &nbsp; ';
            }
        }

    }
});

module.exports = OrgMember;
